<div class="mt-lg">
    @if (documentsLength === 0) {
        <vwui-empty-state [messageTitle]="'PAGE_DOCUMENTS.no_documents.message' | translate"></vwui-empty-state>
    }

    @if (documentsLength !== 0) {
        <vwui-table [compactable]="false">
            <vwui-pagination
                slot="table-pagination"
                [totalItems]="currentPageData?.page?.totalElements"
                [totalPages]="currentPageData?.page?.totalPages"
                [currentPage]="currentPageData?.page?.number + 1"
                [firstItem]="firstItem()"
                [lastItem]="lastItem()"
                (vwuiPaginationChange)="setPage($event.detail)"
            ></vwui-pagination>

            <vwui-table-row>
                @for (column of tableConfig.columns; track column) {
                    <vwui-table-header>
                        @if (column.tooltip === undefined) {
                            <ng-container> {{ column.header }} </ng-container>
                        } @else {
                            <vwui-tooltip [label]="column.tooltip | translate"> {{ column.header }}</vwui-tooltip>
                        }
                    </vwui-table-header>
                }
            </vwui-table-row>

            @if (loadingSpinnerVisible) {
                <vwui-table-row>
                    <vwui-spinner></vwui-spinner>
                </vwui-table-row>
            }

            @if (documentsLength === 0 && !loadingSpinnerVisible) {
                <vwui-table-row>
                    <div class="table-row__text">{{ 'PAGE_DOCUMENTS.no_documents.message' | translate }}</div>
                </vwui-table-row>
            }

            <ng-container>
                @for (document of documents | async; track document) {
                    <vwui-table-row class="vwui-table-row--with-hover" (click)="onDocumentClick(document)" a11yKeyboardClickable>
                        <vwui-table-column>
                            {{ document.originalFileName }}
                        </vwui-table-column>

                        <vwui-table-column >
                            {{ document.modifiedBy }}
                        </vwui-table-column>

                        <vwui-table-column>
                            {{ document.modifiedAt }}
                        </vwui-table-column>
                    </vwui-table-row>
                }
            </ng-container>
        </vwui-table>
    }
</div>

